import { inject } from 'vue';

import type { ICreateRpcClient } from './types';

export function useRpcClient() {
  const rpcClient = inject('rpcClient') as ICreateRpcClient;

  return {
    rpcClient,
  };
}
